import React, { Component } from 'react';
import InputContainer from 'app/components/form/inputs/utils/InputContainer';
import TextFormInput from 'app/components/form/inputs/TextFormInput';
import FormValidator from 'store/validators/FormValidator';
import { inject, observer } from 'mobx-react';
import { translate } from 'i18n/i18n';

@translate()
@inject('store')
@observer
class CreditContactTab extends Component {
    render() {
        const { t, store: { credit } } = this.props;
        const { phone, email } = credit.form;
        const { isPhoneValidForDisplay, isEmailValidForDisplay } = new FormValidator();

        return (
            <div className="tab-container">
                <div className="email-or-phone">{t('COMMON.PHONE_OR_EMAIL')}</div>

                <InputContainer forceRow>
                    <TextFormInput
                        isRequired={!isEmailValidForDisplay(email)}
                        isPhone
                        warningIcon={true}
                        redInputBorder={true}
                        actCodeWarning={true}
                        moduleStore={credit}
                        formFieldName={'phone'}
                        setTitle={t('COMMON.ENTER_PHONE')}
                        changeTitle={t('COMMON.CHANGE_PHONE')}
                        title={t('COMMON.PHONE') + ':'} />

                    <TextFormInput
                        isRequired={!isPhoneValidForDisplay(phone) || credit.phonePreselected}
                        isEmail
                        warningIcon={true}
                        redInputBorder={true}
                        actCodeWarning={true}
                        moduleStore={credit}
                        formFieldName={'email'}
                        setTitle={t('COMMON.ENTER_EMAIL')}
                        changeTitle={t('COMMON.CHANGE_EMAIL')}
                        title={t('COMMON.EMAIL') + ':'} />
                </InputContainer>
                <div className="code-explain">{t('COMMON.ACT_CODE_EXPLAIN')}</div>
            </div>
        )
    }
}

export default CreditContactTab;
